export default __webpack_public_path__ + "static/media/upload.018e3517.svg";